import { message } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

const Disabled = {
    'INVESTIGATION_LEVEL_LOWEST': '项目到达“项目终止”阶段，不可调整项目相关数据！',
    'INVESTIGATION_DATA_LOCK': '项目到达“项目关闭”阶段，不可调整项目相关数据！',
    'TERMINATED_BEFORE_CONTRACT': '项目已在服务合同签署前终止，不可调整项目相关数据',
};

const queryInvestigationStage = function (investigationId, callback, disabledOption = ['INVESTIGATION_LEVEL_LOWEST', 'INVESTIGATION_DATA_LOCK', 'TERMINATED_BEFORE_CONTRACT']){
    const options = {
        method: 'POST',
        url: API_URL.investigation.queryInvestigationStageByInvId,
        data: { investigationId },
        dataType: 'json',
        doneResult: res => {
            const { data } = res;
            this.setState({ invStageList: data }, () => {
                callback && canEditByInvStatus.call(this, callback, disabledOption);
            });
        },
        errorResult: () => {
            this.setState({ loading: false });
        }
    };
    $.sendRequest(options);
}

const canEditByInvStatus = function (callback, disabledOption = ['INVESTIGATION_LEVEL_LOWEST', 'INVESTIGATION_DATA_LOCK', 'TERMINATED_BEFORE_CONTRACT']) {
    const { invStageList: data = [] } = this.state;
    const canEdit = !(data || []).some(i => {
        if (disabledOption.includes(i.operation)) {
            message.error(Disabled[i.operation]);
            return true;
        }
        return false;
    });
    if (canEdit) {
        callback();
    }
}

export { queryInvestigationStage, canEditByInvStatus };


// WEBPACK FOOTER //
// ./src/components/common/queryInvestigationStage.js